(() => {
  const locale = (document.documentElement.lang || '').toLowerCase();
  const currencyLabel = locale.startsWith('ar') ? 'دج' : 'DZD';

  const amountPattern = String.raw`((?:\d{1,3}(?:[ \u202f.,]\d{3})+|\d+))([.,]\d{2})?`;
  const prefixPattern = new RegExp(String.raw`(?:DA|DZD|دج)\s*${amountPattern}`, 'g');
  const suffixPattern = new RegExp(String.raw`${amountPattern}\s*(?:DA|DZD|دج)`, 'g');

  const displayAmount = (amount, decimals) => {
    if (!decimals || /^[.,]00$/.test(decimals)) return amount;
    return `${amount}${decimals}`;
  };

  const normalizeCurrencyText = (text) => {
    let output = String(text || '');
    output = output.replace(prefixPattern, (_match, amount, decimals) => {
      return `${displayAmount(amount, decimals)} ${currencyLabel}`;
    });
    output = output.replace(suffixPattern, (_match, amount, decimals) => {
      return `${displayAmount(amount, decimals)} ${currencyLabel}`;
    });
    return output;
  };

  const shouldSkipTextNode = (node) => {
    const parent = node.parentElement;
    return !parent || Boolean(parent.closest('script, style, textarea, input, template, noscript'));
  };

  const formatTextNode = (node) => {
    if (shouldSkipTextNode(node)) return;
    const current = node.nodeValue || '';
    const next = normalizeCurrencyText(current);
    if (next !== current) node.nodeValue = next;
  };

  const formatNode = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      formatTextNode(node);
      return;
    }
    if (!(node instanceof Element)) return;

    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(formatTextNode);
  };

  const run = () => {
    if (document.body) formatNode(document.body);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        formatTextNode(mutation.target);
        return;
      }
      mutation.addedNodes.forEach(formatNode);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  document.addEventListener('shopify:section:load', run);
})();